import { TYPE_STRING } from './input-types';

export const id = 'city';
export const apiKey = 'City';
export const type = TYPE_STRING;

export const city = {
  id,
  apiKey,
  type,
};
